import React from 'react';

import Dropdown from 'shared/components/Navigation/NavLinks/Dropdown';
import { NavItem } from 'shared/components/Navigation/NavLinks/NavItem';
import { NAV_ITEMS } from 'shared/components/Navigation/NavLinks/constants.jsx';

class ContentLibrary extends React.Component {
  render() {
    const { closeAction, closeNavigation, visible } = this.props;
    return (
      <Dropdown visible={visible}>
        <Dropdown.Header onClick={closeAction}>Content Library</Dropdown.Header>
        {NAV_ITEMS.CONTENT_LIBRARY.map(item => (
          <NavItem
            key={item.title}
            {...item}
            closeAction={closeAction}
            closeNavigation={closeNavigation}
          />
        ))}
      </Dropdown>
    );
  }
}
export default ContentLibrary;
